module.exports = __webpack_public_path__ + "static/img/trial.dbf99d9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trial.gif
// module id = eiUe
// module chunks = 1